import { bool, func, string } from 'prop-types';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { useCheckUser } from '../../hooks/useCheckUser';
import { ENV_CONFIG } from '../../constants/envConfig';
import { USER_TYPE } from '../../constants/userDetailsConstants';
import { useDstState } from '../../contexts/dst/dstContext';
import FilterIcon from '../../resources/images/filter.svg';
import LocationNavigation from '../../resources/images/location-navigation.svg';
import Button from '../global/atoms/button/button';
import { dstDataLocators } from './dataLocators';
import DstSearchForm from './dstSearchForm/DstSearchForm';

const DstLocationSearch = props => {
    const {
        wrapClass,
        getCurrentLocation,
        getStores,
        isCurrentLocationAllowed,
        currentAddress,
        setOpenFilterHandle,
        currentCountry,
        setIsUserLocationUsed,
        isUserLocationUsed,
        setIsCurrentLocationAllowed,
        setuserLatLong,
        userAddress,
        setUserAddress,
        locationDeniedError,
        setLocationDeniedError,
        onClearingAddress,
        renderNeedHelpContact
    } = props;
    const userType = useCheckUser();
    const [{ numberOfFilters }] = useDstState();

    const intl = useIntl();
    const LocationTitle = () => {
        return (
            <h5 className="dst__title" data-testid={''}>
                {ENV_CONFIG.DST_SEARCH_TITLE}
            </h5>
        );
    };
    return (
        <div className={`dst__aside-top ${wrapClass}`}>
            <LocationTitle />
            <DstSearchForm
                placeholderText={ENV_CONFIG.DST_SEARCH_PLACEHOLDER}
                locationDeniedError={locationDeniedError}
                getStores={getStores}
                isCurrentLocationAllowed={isCurrentLocationAllowed}
                currentAddress={currentAddress}
                getCustomCountryCode={userType === USER_TYPE.GUEST && isCurrentLocationAllowed ? currentCountry : ''}
                setIsUserLocationUsed={setIsUserLocationUsed}
                isUserLocationUsed={isUserLocationUsed}
                setIsCurrentLocationAllowed={setIsCurrentLocationAllowed}
                setuserLatLong={setuserLatLong}
                userAddress={userAddress}
                setUserAddress={setUserAddress}
                setLocationDeniedError={setLocationDeniedError}
                onClearingAddress={onClearingAddress}
            />
            <div className="dst__filter-wrap">
                <div className="filter_wrap">
                    <Button
                        className="button button-square button_iconleft button-medium"
                        onClick={setOpenFilterHandle}
                        buttonAriaLabel={`${intl.formatMessage({ id: 'location:filter-icon' })}`}>
                        <FilterIcon data-testid={''} />
                    </Button>
                    {!numberOfFilters && (
                        <span 
                        // data-testid={locationDataLocators.location_landing_filter_text}
                        >
                            {intl.formatMessage({ id: 'location:filter-text' })}
                        </span>
                    )}
                    {numberOfFilters > 0 && (
                        <span
                            className="filterTextGreen"
                            // data-testid={locationDataLocators.location_landing_filter_text}
                            >
                            {intl.formatMessage({ id: 'location:filter-text' })}
                            {` (${numberOfFilters})`}
                        </span>
                    )}
                </div>

                <Button
                    onClick={getCurrentLocation}
                    className="button button-outline-primary button-medium location__current"
                    data-testid={dstDataLocators.current_location_cta}
                    buttonAriaLabel={`${intl.formatMessage({ id: 'location:current-location-text' })}`}>
                    <LocationNavigation className="button_iconleft" />
                    {intl.formatMessage({ id: 'location:current-location-text' })}
                </Button>
            </div>
            {renderNeedHelpContact && <div>{renderNeedHelpContact()}</div>}
        </div>
    );
};

DstLocationSearch.propTypes = {
    locationDeniedError: bool,
    wrapClass: string,
    setLocationDeniedError: func,
    renderNeedHelpContact: func,
    setOpenFilterHandle: func
};

DstLocationSearch.defaultProps = {
    locationDeniedError: false,
    wrapClass: '',
    setLocationDeniedError: () => {},
    renderNeedHelpContact: () => {},
    setOpenFilterHandle: () =>{}
};
export default memo(DstLocationSearch);
